<template>
  <div class="imgsort-list">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">订单时间</span>
        <el-date-picker v-model="date" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">作品名称</span>
        <el-input class="w200" maxlength="20" style="width:200px; " v-model="designName" placeholder="请输入作品名称"></el-input>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">按月查询</span>
        <el-date-picker v-model="month" type="month" placeholder="选择月"></el-date-picker>
      </div>
      <div class="condition-wrap">
        <el-button type="primary" @click="search">筛选</el-button>
      </div>
    </div>
    <div class="summary">
      <div class="item">总收入&nbsp; ￥{{ cashOutInfo.sumOrderPrice }}</div>
      <div class="item">已提现&nbsp; ￥{{ cashOutInfo.cashTotal }}</div>
      <div class="item">可提现&nbsp; ￥{{ cashOutInfo.ableCashTotal }}</div>
      <div class="item">处理中&nbsp; ￥{{ cashOutInfo.checkTotal }}</div>
      <div class="item">
        <el-link type="primary" @click="showWithDraied">提现记录</el-link>
      </div>
      <div class="item">
        <el-link type="primary" @click="showWithdraw">申请提现</el-link>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" size="middle" border stripe>
      <el-table-column label="作品图案" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.designUrl + '?x-oss-process=image/resize,w_200'" width="100" />
        </template>
      </el-table-column>
      <el-table-column prop="designName" label="作品名称" align="center"></el-table-column>
      <el-table-column prop="price" label="单价（￥）" align="center"></el-table-column>
      <el-table-column prop="createTime" label="订单时间" align="center"></el-table-column>
      <el-table-column label="是否允许提现" align="center">
        <template slot-scope="scope">
          {{ scope.row.status == 7 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="sumPrice" label="支付金额（￥）" align="center"></el-table-column>
      <el-table-column label="防伪码类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.countryType == 2 ? '国内' : '国外' }}
        </template>
      </el-table-column>
      <el-table-column prop="count" label="商品数量" align="center"></el-table-column>
      <!-- <el-table-column label="实际获得" align="center"></el-table-column> -->
      <el-table-column prop="brandName" label="品牌及艺术家联名名称" align="center"></el-table-column>
      <el-table-column prop="publishDate" label="产品预计上市时间" align="center"></el-table-column>
      <el-table-column label="设计图" align="center">
        <template slot-scope="scope">
          <img style="cursor: pointer;" @click="searchBig(scope.row.designImgUrl)" :src="scope.row.designImgUrl + '?x-oss-process=image/resize,w_200'" width="100" />
        </template>
      </el-table-column>

    </el-table>
    <div class="site-page">
      <el-pagination background :page-count="totalPage" :current-page="pageNum" @current-change="currentChange" layout="prev, pager, next, jumper"></el-pagination>
    </div>
    <el-dialog :close-on-click-modal="false" @close="reset" title="申请提现" :visible.sync="withdrawVisiable" width="500px">
      <div v-if="isCompany">
        <el-form :model="companyCashForm" size="small" label-width="120px">
          <el-form-item label="到账支付宝">
            {{alipayAccount}}
          </el-form-item>
          <el-form-item label="提现金额">
            <el-input type="number" v-model="companyCashForm.money" @input="companyMoneyChange" placeholder="请输入提现金额">
              <template slot="prepend"
                >￥</template
              >
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="实际提现金额">
            {{companyCashForm.money}}
          </el-form-item> -->
          <el-form-item label="可提现金额"> ￥{{ cashOutInfo.ableCashTotal }} </el-form-item>
          <el-form-item label="发票物流公司">
            <el-input v-model="companyCashForm.expressName" placeholder="请输入物流公司" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="发票物流单号">
            <el-input v-model="companyCashForm.expressNo" placeholder="请输入物流单号" rows="3" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="发票照片">
            <MyUpload info="仅支持jpep、png, 小于20M" :imgKey.sync="companyCashForm.billKey" :url="companyCashForm.billPicUrl" />
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <el-form :model="personCashForm" size="small" label-width="120px">
          <el-form-item label="到账支付宝">
            {{alipayAccount}}
          </el-form-item>
          <el-form-item label="提现金额">
            <el-input type="number" v-model="personCashForm.money" @input="personMoneyChange" placeholder="请输入提现金额">
              <template slot="prepend"
                >￥</template
              >
            </el-input>
          </el-form-item>
          <el-form-item label="实际提现金额">
            {{Math.round(personCashForm.money * (100-7)) / 100}}
          </el-form-item>
          <el-form-item label="可提现金额">
            ￥{{cashOutInfo.ableCashTotal}}
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button @click="withdrawVisiable = false">取 消</el-button>
        <el-button type="primary" @click="withdraw">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提现记录" :visible.sync="withdraiedVisiable" width="800px">
      <div>
        <el-table :data="withdraiedRecord.tableData" style="width: 100%" size="middle" border stripe>
          <el-table-column prop="createTime" label="提现时间" align="center"></el-table-column>
          <el-table-column align="center" label="提现方式">
            <template slot-scope="scope">
              {{ scope.row.cashType == 2 ? '微信' : '支付宝' }}
            </template>
          </el-table-column>
          <el-table-column prop="money" label="申请金额" align="center"></el-table-column>
          <el-table-column prop="realMoney" label="实际提现金额" align="center"></el-table-column>
          <el-table-column label="提现状态" align="center">
            <template slot-scope="scope">
              {{ statusObj[scope.row.status] }}
            </template>
          </el-table-column>
          <el-table-column prop="realMoney" label="失败原因" align="center">
            <template slot-scope="scope">
              {{ scope.row.remark || '-' }}
            </template>
          </el-table-column>
        </el-table>
        <div class="site-page">
          <el-pagination background :page-count="withdraiedRecord.totalPage" :current-page="withdraiedRecord.pageNum" @current-change="currentChange2" layout="prev, pager, next, jumper"></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="设计图" :visible.sync="designImgVisible" width="500px">
      <div v-if="designImgVisible">
        <img :src="currentDesignImgUrl" style="width: 100%;" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '../lib/API'
import dayjs from 'dayjs'
import MyUpload from '../components/common/MyUpload.vue'
export default {
  name: 'MyIPOrder',
  components: {
    MyUpload,
  },
  data() {
    return {
      tableData: [],
      pageNum: 1,
      totalPage: 0,
      designName: '',
      // 是否是公司
      isCompany: false,
      // 支付宝账号
      alipayAccount: '',
      // 公司提现
      companyCashForm: {
        billKey: '',
        billPicUrl: '',
        expressName: '',
        expressNo: '',
        money: '',
      },
      // 个人提现
      personCashForm: {
        money: '',
      },
      withdrawVisiable: false,
      withdrawPrice: '',
      withdraiedVisiable: false,
      date: [],
      month: '',
      cashOutInfo: {},
      withdraiedRecord: {
        pageNum: 1,
        totalPage: 0,
        tableData: []
      },
      statusObj: {
        0: '待审核',
        1: '审核通过',
        2: '审核失败',
        3: '打款成功',
        4: '打款失败',
      },
      currentDesignImgUrl: '',
      designImgVisible: false,
    }
  },
  created() {
    this.isCompany = localStorage.getItem('authorType') == 2
    this.authorId = localStorage.getItem('authorId')
    this.getCashOutInfo()
    this.getList()
    this.getCertInfo()
  },
  methods: {
    personMoneyChange(val) {
      this.personCashForm.money = this.moneyChange(val)
    },
    companyMoneyChange(val) {
      this.companyCashForm.money = this.moneyChange(val)
    },
    moneyChange(val) {
      let arr = val.split('.')
      if(arr.length > 1 && arr[1].length > 2) {
        val = arr[0] + '.' + arr[1].slice(0, 2)
      }
      return val
    },
    getCertInfo () {
      new API(this).POST({
        url: `/author/getCertDetail?authorId=${this.authorId}`,
        cb: res => {
          this.alipayAccount = res.alipayAccount
        }
      })
    },
    searchBig (url) {
      this.designImgVisible = true
      this.currentDesignImgUrl = url
    },
    reset() {
      this.companyCashForm = {
        billKey: '',
        billPicUrl: '',
        expressName: '',
        expressNo: '',
        money: '',
      }
      this.personCashForm = {
        money: '',
      }
    },
    search() {
      this.pageNum = 1
      this.getList()
    },
    currentChange(pageNum) {
      this.pageNum = pageNum
      this.getList()
    },
    currentChange2(pageNum) {
      this.withdraiedRecord.pageNum = pageNum
      this.getWithDraiedRecord()
    },
    getList(val) {
      let startTime = ''
      let endTime = ''
      console.log(this.date)
      if (this.date.length > 1) {
        let startDate = dayjs(this.date[0]).format('YYYY-MM-DD')
        let endDate = dayjs(this.date[1]).format('YYYY-MM-DD')
        startTime = `${startDate} 00:00:00`
        endTime = `${endDate} 23:59:59`
      }
      if (this.month) {
        let date = dayjs(this.month).format('YYYY-MM-DD')
        startTime = `${date} 00:00:00`  
        let year = this.month.getFullYear()
        let month = this.month.getMonth()
        let endDate = new Date(year, month + 1, 0)
        endTime = `${dayjs(endDate).format('YYYY-MM-DD')} 23:59:59`
      }
      new API(this).POST({
        url: '/iporder/listWithAuthor',
        params: {
          count: true,
          pageNum: this.pageNum,
          pageSize: 10,
          designName: this.designName,
          startTime,
          endTime
        },
        cb: res => {
          let { pages, result } = res
          this.totalPage = pages
          this.tableData = result
        }
      })
    },
    withdraw() {
      if (this.isCompany) {
        let { money, expressName, expressNo, billKey } = this.companyCashForm
        if (!money || !expressName || !expressNo || !billKey) return this.$message.error('请输入完整的提现信息')
        if (money > this.cashOutInfo.ableCashTotal) return this.$message.error('提现金额不能大于可提现金额')
      } else {
        let { money } = this.personCashForm
        if (!money) return this.$message.error('请输入完整的提现信息')
        if (money > this.cashOutInfo.ableCashTotal) return this.$message.error('提现金额不能大于可提现金额')
      }
      let params = this.isCompany ? this.companyCashForm : this.personCashForm
      new API(this).POST({
        url: '/cashOutRecord/addCashOutRecord',
        params,
        cb: res => {
          this.withdrawVisiable = false
          this.$message.success('操作成功')
          this.getList()
          this.getCashOutInfo()
        }
      })
    },
    showWithdraw() {
      let aliVerityStatus = localStorage.getItem("aliVerityStatus")
      if (aliVerityStatus != 1 && !this.isCompany) {
        this.$confirm('请先进行支付宝实名认证，点击确定去认证', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.$router.push('/certificateInfo')
        }).catch(() => {
        });
        // this.$alert('请先进行支付宝实名认证，点击确定去认证', '提示', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     this.$router.push('/certificateInfo')
        //   }
        // });
        return
      }
      this.withdrawVisiable = true
    },
    showWithDraied() {
      this.withdraiedVisiable = true
      this.withdraiedRecord.pageNum = 1
      this.getWithDraiedRecord()
    },
    getWithDraiedRecord() {
      new API(this).POST({
        url: '/cashOutRecord/listWithPageSelf',
        params: {
          count: true,
          pageNum: this.withdraiedRecord.pageNum,
          pageSize: 10
        },
        cb: res => {
          let { pages, result } = res
          this.withdraiedRecord.totalPage = pages
          this.withdraiedRecord.tableData = result
        }
      })
    },
    getCashOutInfo() {
      new API(this).POST({
        url: '/iporder/getAuhtorStatistics',
        cb: res => {
          this.cashOutInfo = res
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.summary {
  display: flex;
  margin: 20px 0;
  .item {
    margin-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyIPOrder.vue